import type * as React from 'react';
import { useIntl } from 'react-intl';

const DEGREE_LABELS: Record<number, { id: string; defaultMessage: string }> = {
  1: {
    id: 'A11Y_XDS_CONNECTION_DEGREE_1',
    defaultMessage: '1st degree contact',
  },
  2: {
    id: 'A11Y_XDS_CONNECTION_DEGREE_2',
    defaultMessage: '2nd degree contact',
  },
  3: {
    id: 'A11Y_XDS_CONNECTION_DEGREE_3',
    defaultMessage: '3rd degree contact',
  },
};

export const useConnectionDegreeLabel = (
  childContent: React.ReactNode
): string | undefined => {
  const intl = useIntl();

  if (childContent === null || childContent === undefined) {
    return undefined;
  }

  const degree = Number(childContent);

  if (!isNaN(degree) && DEGREE_LABELS[degree]) {
    return intl.formatMessage(DEGREE_LABELS[degree]);
  }

  return undefined;
};
